import { Flame } from 'lucide-react';
import ChecklistBoard, { type ChecklistConfig } from './checklist/ChecklistBoard';
import { SMOKE_SECTIONS } from './checklist/smokeSections';

/**
 * Platform-admin Phase 1 manual smoke test checklist for The Polished Version.
 * A thin configuration over the shared {@link ChecklistBoard}; the 12 checks
 * come from docs/phase-1-manual-smoke-test.md.
 */
const SMOKE_CONFIG: ChecklistConfig = {
  title: 'Smoke Test Checklist',
  icon: Flame,
  intro:
    'Phase 1 manual smoke test for The Polished Version. Work through each check the way a real ' +
    'cleaning business would before launch, mark Pass or Fail, and record notes. Results are saved ' +
    'to the shared QA record when online, with this browser kept as a fallback.',
  storageKey: 'tpv-smoke-checklist-v1',
  recordNoun: 'QA record',
  submissionsTitle: 'Saved smoke test submissions',
  submissionsDescription: 'Platform admins can view browser smoke-test results saved by reviewers.',
  submissionsEmpty: 'No saved smoke test submissions yet.',
  sections: SMOKE_SECTIONS,
};

const SmokeChecklist = () => <ChecklistBoard config={SMOKE_CONFIG} />;

export default SmokeChecklist;
